'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

exports.default = function () {
    var Coupon = function () {
        function Coupon(modal, productId) {
            (0, _classCallCheck3.default)(this, Coupon);

            this.selector = modal;
            this.productId = productId;

            this.inputSelector = $('#ProductId-' + this.productId + ' input', this.selector);
            this.unitPriceSelector = $('#voucher-price-' + this.productId, this.selector);
            this.totalPriceSelector = $('#voucher-total-price-' + this.productId, this.selector);
            this.paymentTypesListSelector = $('#paymentList', this.selector);
            this.selectedPaymentTypeSelector = $('.paymentBox-type[checked=checked]', this.selector);

            this.paymentTypePrice = 0;
            this.amount = this.currentAmount();

            this._calculateAndRenderPrices();
        }

        (0, _createClass3.default)(Coupon, [{
            key: 'currentAmount',
            value: function currentAmount() {
                return (/^\d+$/.test(this.inputSelector.val()) ? parseInt(this.inputSelector.val()) : 1
                );
            }
        }, {
            key: 'setPaymentTypePrice',
            value: function setPaymentTypePrice(price) {
                this.paymentTypePrice = price;
                this.changeAmount(this.amount);
            }
        }, {
            key: 'increaseAmount',
            value: function increaseAmount() {
                this.changeAmount(this.currentAmount() + 1);
            }
        }, {
            key: 'reduceAmount',
            value: function reduceAmount() {
                this.changeAmount(this.currentAmount() - 1);
            }
        }, {
            key: 'changeAmount',
            value: function changeAmount(amount) {
                if (amount <= 0) return;
                this.amount = amount;
                this.inputSelector.val(this.amount);

                this._calculateAndRenderPrices();
            }
        }, {
            key: '_calculateAndRenderPrices',
            value: function _calculateAndRenderPrices() {
                var unitPrice = parseFloat(this.unitPriceSelector.attr('data-unit-price')) || 0;

                this.vouchersPrice = this.amount > 0 ? this.amount * unitPrice : unitPrice;
                this._updatePaymentTypePrices(this.vouchersPrice);
                this._renderVouchersPrice();
                this._updateTotalPrice();
            }
        }, {
            key: '_updatePaymentTypePrices',
            value: function _updatePaymentTypePrices(vouchersPrice) {
                var _this = this;

                paymentTypeService.getPaymentTypesForVoucherWithValidPrice(vouchersPrice, false).done(function (result) {
                    result.map(function (item) {
                        var inputSelector = $('#SelectedPaymentTypeId-' + item.id, _this.paymentTypesListSelector);
                        var priceSelector = $('#payment-type-price-id-' + item.id, _this.paymentTypesListSelector);

                        if (inputSelector.length > 0) {
                            inputSelector.attr('data-payment-type-price', item.paymentPrice);
                            _this._renderPaymentTypePrice(priceSelector, item.paymentPrice);
                        }
                    });
                    _this.paymentTypePrice = parseFloat(_this.selectedPaymentTypeSelector.length > 0 ? _this.selectedPaymentTypeSelector.attr('data-payment-type-price') : 0);
                    _this._updateTotalPrice();
                }).fail(function (err) {
                    _message2.default.error(err.responseJSON.message);
                });
            }
        }, {
            key: '_updateTotalPrice',
            value: function _updateTotalPrice() {
                this.totalPrice = this.vouchersPrice + this.paymentTypePrice;
                this._renderTotalPrice();
            }
        }, {
            key: '_renderPaymentTypePrice',
            value: function _renderPaymentTypePrice(selector, price) {
                selector.empty();
                var finalPrice = price > 0 ? (0, _linksoftAlbatros.formatPrice)(price, _linksoftAlbatros.PriceType.CartTotalPrice) : Resx.App.FreeOfCharge;
                selector.append('<strong><span class="text-nowrap">' + finalPrice + '</span></strong>');
            }
        }, {
            key: '_renderVouchersPrice',
            value: function _renderVouchersPrice() {
                this.unitPriceSelector.empty();
                this.unitPriceSelector.append('<strong><span class=\'text-nowrap\'>' + (0, _linksoftAlbatros.formatPrice)(this.vouchersPrice, _linksoftAlbatros.PriceType.CartTotalPrice) + '</span></strong>');
            }
        }, {
            key: '_renderTotalPrice',
            value: function _renderTotalPrice() {
                this.totalPriceSelector.empty();
                this.totalPriceSelector.append((0, _linksoftAlbatros.formatPrice)(this.totalPrice, _linksoftAlbatros.PriceType.OrderTotalPrice));
            }
        }]);
        return Coupon;
    }();

    $('[data-buy-voucher]', this).click(function (e) {
        var _this2 = this;

        e.preventDefault();
        var $this = $(this);

        $this.addClass('btn--pending');
        if (!_abp2.default.session) {
            (0, _ajax2.default)({
                url: '/Account/AuthenticateAnonymous',
                method: 'post',
                contentType: 'application/json',
                dataType: 'json'
            }).done(function (res) {
                $('input[name="__RequestVerificationToken"]').val(_cookie2.default.getCookie('XSRF-TOKEN'));
                openModal(_this2);
            }).fail(function (err) {
                _message2.default.error(err.responseJSON.error.message);
            }).always(function (res) {
                return $this.removeClass('btn--pending');
            });
        } else {
            openModal(this);
        }
    });

    function openModal(selector) {
        var productId = $(selector).attr('data-buy-voucher');
        if (productId === undefined) return;

        $('#buy-voucher-modal .modal-content').load((0, _urls2.default)('buyVoucher', { id: productId }), function (result) {
            hookUpEvents(this, new Coupon($(this), productId));
        });
    }

    function reEnableSaveButton() {
        var saveButton = document.querySelector('.btn--pending');
        if (!saveButton) return;

        saveButton.classList.remove('btn--pending');
        saveButton.disabled = false;
    }

    function hookUpEvents(selector, source) {

        $('#buy-voucher-modal').modal("show");

        $('.btn__square--minus', selector).on("click", function (e) {
            e.preventDefault();
            source.reduceAmount();
        });

        $('.btn__square--plus', selector).on("click", function (e) {
            e.preventDefault();
            source.increaseAmount();
        });

        $('#Amount', selector).on("change paste keyup", function (e) {
            e.preventDefault();
            source.changeAmount(source.currentAmount());
        });

        $('.paymentBox-type', selector).on("change", function (e) {
            e.preventDefault();
            source.selectedPaymentTypeSelector = $(this);
            source.setPaymentTypePrice(parseFloat(source.selectedPaymentTypeSelector.attr('data-payment-type-price')));
        });

        $("#buy-voucher-modal").on("hidden.bs.modal", function () {
            $('.modal-content', this).empty();
        });

        window.linksoft.inputAnimation.init();

        $('.btn--pending').removeClass('btn--pending');

        var saverParameters = {
            commonSaveInputSelector: '.common-save-input,.common-save-wrapper input,input[name=SelectedPaymentTypeId]:checked',
            commonSaveValidate: true,
            commonSaverValidFailedAction: function commonSaverValidFailedAction(event, inputList) {
                return validationFailedAction(event, inputList);
            }
        };

        var saveButtonAnonymous = selector.querySelector('#purchaseVoucherAjaxButton');
        if (saveButtonAnonymous) {
            registerPhoneValidation();
            saveButtonAnonymous.addEventListener('click', function (event) {
                compilePhoneWithPrefix();
                setPurchaseButtonAttributes(saveButtonAnonymous, '/Voucher/PurchaseVoucherAnonymousAjax', event, saverParameters);
            });
        }
        var saveButtonRegistered = selector.querySelector('#purchaseVoucherRegisteredAjaxButton');
        if (saveButtonRegistered) {
            saveButtonRegistered.addEventListener('click', function (event) {
                setPurchaseButtonAttributes(saveButtonRegistered, '/Voucher/PurchaseVoucherRegisteredAjax', event, saverParameters);
            });
        }

        function setPurchaseButtonAttributes(button, saveUrl, event, saverParameters) {
            saverParameters.commonSaveUrl = saveUrl;
            button.classList.add('btn--pending');
            button.disabled = true;

            _commonSaverLibrary.commonSaverLibrary.saveCommon(event, function (httpRequest, rspObj, saveParams) {
                return purchaseVoucherComplete(httpRequest, rspObj, saveParams);
            }, saverParameters);
        }

        function validationFailedAction(event, inputList) {
            var hasConsent = _common2.default.getElementPropertySafe('#HasShoppingConditionsConsent', 'checked');
            _common2.default.setClassSafe('.above__submit.consent-pane', 'warning', hasConsent);
            var shoppingConsentChb = [].concat((0, _toConsumableArray3.default)(inputList)).find(function (i) {
                return i.id === 'HasShoppingConditionsConsent';
            });

            if (shoppingConsentChb) {
                if (!shoppingConsentChb.checked) _message2.default.error(Resx.Messages.NoShoppingConditionsConsent);

                if (!shoppingConsentChb.changeregistered) {
                    shoppingConsentChb.addEventListener('change', function (e) {
                        _common2.default.setClassSafe('.above__submit.consent-pane', 'warning', e.target.checked);
                    });
                    shoppingConsentChb.changeregistered = true;
                }
            }
            reEnableSaveButton();
        }
    }

    function registerPhoneValidation() {
        _common2.default.registerPhoneNumberValidation('input');

        var phoneElement = document.getElementById('PhoneNumber');
        if (!phoneElement || !phoneElement.dataset.valRegexPattern) return;

        var message = phoneElement.dataset.msg || Resx.Validation.PhoneFormatStrict_ValidationError;
        _common2.default.registerRegexValidation(phoneElement, phoneElement.dataset.valRegexPattern, message);
    }

    function compilePhoneWithPrefix() {
        try {
            var phoneWithCodeElement = document.getElementById('PhoneNumberWithCode');
            var phoneNumberElement = document.getElementById('PhoneNumber');
            var phonePrefixElement = document.getElementById('PhonePrefix');
            var phoneNum = phoneNumberElement.value.replaceAll(/\s/g, '').trim();

            phoneWithCodeElement.value = '+' + phonePrefixElement.value + phoneNum;
        } catch (e) {
            console.error('Error in compilePhoneWithPrefix. ', e);
        }
    }

    function purchaseVoucherComplete(httpRequest, rspObj, saveParams) {
        try {
            if (!rspObj.result.success) {
                (0, _sweetalert2.default)({ text: Resx.Common.Error, title: rspObj.result.message, icon: 'error' });
                console.error('Error in purchaseVoucherComplete. Detail: ' + rspObj.result.detail);
                return;
            }

            if (rspObj.result.redirectUrl) {
                window.setTimeout(function () {
                    location.assign(rspObj.result.redirectUrl);
                }, 500);
            } else {
                (0, _sweetalert2.default)({ text: Resx.Common.Success, title: rspObj.result.message, icon: 'icon--van' });
            }
        } catch (e) {
            (0, _sweetalert2.default)({ text: Resx.Common.Error, title: Resx.Common.AjaxError, icon: 'error' });
            console.error('Error in purchaseVoucherComplete. ', e);
        } finally {
            window.setTimeout(function () {
                reEnableSaveButton();
            }, 10000);
        }

        console.debug(httpRequest, rspObj, saveParams);
    }

    // prasacky, ale nevim jak jinak hooknout zpet eventy po .ajax postback volani
    $(function () {
        var modal = $('#buy-voucher-modal .modal-content');
        var productId = $('#ProductId', $(modal)).val();
        if (productId === undefined) return;
        hookUpEvents(modal, new Coupon($(modal), productId));
    });
};

var _urls = require('../urls');

var _urls2 = _interopRequireDefault(_urls);

var _abp = require('abp');

var _abp2 = _interopRequireDefault(_abp);

var _ajax = require('linksoft/utils/ajax');

var _ajax2 = _interopRequireDefault(_ajax);

var _cookie = require('linksoft/utils/cookie');

var _cookie2 = _interopRequireDefault(_cookie);

var _linksoftAlbatros = require('linksoft-albatros');

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _message = require('linksoft/message');

var _message2 = _interopRequireDefault(_message);

var _commonSaverLibrary = require('../libraries/commonSaverLibrary');

var _common = require('../common');

var _common2 = _interopRequireDefault(_common);

var _sweetalert = require('sweetalert');

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)("App", "Validation", "Common", "Messages");

var paymentTypeService = _abp2.default.services.api.paymentType;
var $ = require("jquery");
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/buyVoucher.js
// module id = 1058
// module chunks = 1